<div class="loadingSpinner">
    <div class="loadingSpinner-spinner"></div> 
    <p class="loadingSpinner-message" *ngIf="message">{{message}}</p>
</div>